import { FC, ReactElement } from 'react';

import { BadgeSkeletons } from './skeletons';

import './Badge.scss';

interface BadgeProps {
    isLoading: boolean;
    count: number;
    className?: string;
}

export const Badge: FC<BadgeProps> = ({
    isLoading,
    count,
    className = '',
}): ReactElement => (
    <div className={`badge ${className}`}>
        {isLoading && (
            <BadgeSkeletons className="badge__count" />
        )}

        {!isLoading && count > 0 && (
            <div className="badge__count">
                {count}
            </div>
        )}
    </div>
);
